import { Fragment } from 'react';

const ImagePreview = (props) =>{
  const noImage = ["", null, undefined, "none"];
  const { style, src } = props;
  const image= noImage.includes(src) ? `assets/images/not-found.png` : src;
return (
    <Fragment>
      <img
        alt='No preview'
        className="no-preview"
        style={style}
        src={image}
      />
    </Fragment>
);
}
ImagePreview.defaultProps = {
    src: "",
    style: {},
  };

export default ImagePreview;
